import { render, staticRenderFns } from "./AgentIssue.vue?vue&type=template&id=5fcfb4f0&"
import script from "./AgentIssue.vue?vue&type=script&lang=js&"
export * from "./AgentIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports